import { Button } from '@material-ui/core';
import { Fragment, useState, memo } from 'react';

import { AcknowledgedByDialog } from '~components/Alarms/AcknowledgedByDialog';

interface AcknowledgedByButtonProps {
  id: number;
  dateTime: string;
  backTo?: string;
}

export const AcknowledgedByButton = memo(({ id, dateTime, backTo }: AcknowledgedByButtonProps) => {
  const [open, setOpen] = useState(false);

  return <Fragment>
    <Button
      variant="outlined"
      color="primary"
      size="small"
      onClick={() => setOpen(true)}
    >
      Acknowledged By
    </Button>

    <AcknowledgedByDialog
      open={open}
      id={id}
      dateTime={dateTime}
      onClose={() => setOpen(false)}
      backTo={backTo}
    />
  </Fragment>;
});
